import type { IRatingMatrixFrameworkConsideration } from '__generated__';

export function buildConsiderationTemplateFilter(templateId: number): string {
  return `frameworkTemplateID==${templateId}`;
}

export function getNextSortOrder(items: IRatingMatrixFrameworkConsideration[]): number {
  if (items.length === 0) {
    return 1;
  }

  return Math.max(...items.map((item) => item.sortOrder)) + 1;
}

export type SortOrderPatch = {
  id: number;
  sortOrder: number;
};

export function getSortOrderPatches(
  original: IRatingMatrixFrameworkConsideration[],
  startIndex: number,
  endIndex: number,
): SortOrderPatch[] {
  const copyData = [...original];
  const deleted = copyData.splice(startIndex, 1);
  copyData.splice(endIndex, 0, ...deleted);

  const min = Math.min(startIndex, endIndex);
  const max = Math.max(startIndex, endIndex);
  const patches: SortOrderPatch[] = [];

  for (let i = min; i <= max; i++) {
    const reorderedItem = copyData[i];
    const originalItem = original[i];

    if (!reorderedItem || !originalItem) {
      continue;
    }

    const newSortOrder = originalItem.sortOrder;

    if (reorderedItem.sortOrder !== newSortOrder) {
      patches.push({ id: reorderedItem.id, sortOrder: newSortOrder });
    }
  }

  return patches;
}
